import { MessageBubble } from '../containers/channel/message-bubble';
import { HStack, VStack } from '../layouts/stack.layout';
import { v4 as uuid4 } from 'uuid';
import Button from '../button/v2/button';

const styles = {
  container: 'w-[calc(100%-40px)]',
};

type MessageListProps = {
  messages: string[];
  owned: boolean;
};
export default function MessageGroupList({
  messages,
  owned,
}: MessageListProps) {
  const getRounding = (idx: number, owned: boolean) => {
    if (owned) {
      if (idx === 0) return 'start-owned';
      if (idx === messages.length - 1) return 'end-owned';
      else return 'inbetween-owned';
    } else {
      if (idx === 0) return 'start';
      if (idx === messages.length - 1) return 'end';
      else return 'inbetween';
    }
  };

  return (
    <VStack
      gap="xs"
      extensions={styles.container}
      align={owned ? 'end' : 'start'}
    >
      {messages.map((message, idx) => (
        <HStack
          gap="sm"
          rowReverse={owned}
          extensions="items-center message-group-item w-full"
        >
          <MessageBubble
            variant={getRounding(idx, owned)}
            key={uuid4()}
            message={message}
            owned={owned}
          />
          <HStack
            key={uuid4()}
            gap="xs"
            extensions="message-controls items-center"
          >
            <Button color="base-200" asIcon="react" size="sm" />
            <Button color="base-200" asIcon="dots" size="sm" />
          </HStack>
        </HStack>
      ))}
    </VStack>
  );
}
